import moment from "moment";
import React, { useEffect, useState } from "react";
import { Badge, Button, Pagination, Select, Table } from "flowbite-react";
import { FaArrowsLeftRight } from "react-icons/fa6";
import axios from "../../config/axiosInstance";
import { useQuery, useQueryClient } from "react-query";
import { ADMIN, CATEGORIES } from "../../config/apiConfig";
import { TbLockSearch } from "react-icons/tb";
import Drawer from "../Drawer";
import CompanyQueriesForm from "../forms/CompanyQueriesForm";
import { IoMdAdd, IoMdSearch } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { FaFileInvoiceDollar, FaRegEdit } from "react-icons/fa";
import CompanyEditForm from "../forms/CompanyEditForm";
import EmptyTable from "./EmptyTable";
import {
  MdBlock,
  MdFilterListAlt,
  MdOutlineRemoveRedEye,
} from "react-icons/md";
import ModalDelete from "../modals/ModalDelete";
import TableLoading from "../TableLoading";
import { Tooltip } from "react-tooltip";
import CompanyInvoiceForm from "../forms/CompanyInvoiceForm";
import { useForm } from "react-hook-form";
import Input from "../inputs/Input";
import SelectInput from "../inputs/SelectInput";
import AutoCompleteInput from "../inputs/Autocomplete";
import { useApplication } from "../../contexts/ApplicationContext";

const AdminCustomersTableSpecific = ({ companyId, isActive }) => {
  const { userPermission } = useApplication();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const onPageChange = (page) => setCurrentPage(page);
  const [searchName, setSearchName] = useState("");
  const [nameParam, setNameParam] = useState("");
  const [isDrawerPermissionQueries, setIsDrawerPermissionQueries] =
    useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isDrawerViewInvoice, setIsDrawerViewInvoice] = useState(false);
  const [isDrawerEditCustomer, setIsDrawerEditCustomer] = useState(false);
  const [isOpenModalBlock, setOpenModalBlock] = useState(false);
  const [isLoadingBlock, setIsLoadingBlock] = useState(false);
  const [typeBlock, setTypeBlock] = useState(0);
  const [isVisibleFilter, setIsVisibleFilter] = useState(true);
  const [selectedRepresentative, setSelectedRepresentative] = useState({
    label: "Todos os representantes",
    value: "",
  });
  const itemsPerPage = 20;

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  const {
    isLoading: isLoadingListCustomers,
    error: errorListCustomers,
    data: listCustomers,
  } = useQuery(
    [
      "listCustomers",
      currentPage,
      nameParam,
      watch("createdAt"),
      watch("status"),
      watch("typePayment"),
      watch("typeCustomer"),
      watch("isIntegrator"),
      companyId,
    ],
    async () => {
      const { data } = await axios.get(
        `${
          ADMIN.GET_CUSTOMERS
        }?page=${currentPage}&search=${nameParam}&createdAt=${watch(
          "createdAt"
        )}&status=${watch("status")}&typeCustomer=${watch(
          "typeCustomer"
        )}&typePayment=${watch("typePayment")}&isIntegrator=${watch(
          "isIntegrator"
        )}&representativeId=${companyId}&itemsPerPage=${itemsPerPage}`
      );

      setTotalPages(data.data.totalPages || 1);
      setTotalCount(data.data.totalCount || 0);

      return data.data.data;
    },
    {
      enabled: isActive,
    }
  );

  const {
    isLoading: isLoadingCategories,
    error: errorCategories,
    data: categories,
  } = useQuery(
    ["categories"],
    async () => {
      const { data } = await axios.get(
        `${CATEGORIES.GET_ALL}?itemsPerPage=${-1}`
      );

      return data.data.data;
    },
    { enabled: isActive }
  );

  const handleSearchName = (e) => {
    e.preventDefault();
    setNameParam(searchName);
  };

  const handleEditPermissionQueries = (company) => {
    setSelectedCompany(company);
    setIsDrawerPermissionQueries((prevState) => !prevState);
  };

  const blockUnlockCustomer = async (type = 0) => {
    try {
      setIsLoadingBlock(true);
      await axios.put(`${ADMIN.GET_COMPANY}/${selectedCompany.id}`, {
        status: type,
      });

      queryClient.invalidateQueries(["listCustomers", currentPage]);
      setOpenModalBlock(false);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingBlock(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSearchName} className="">
        <div className="bg-white p-3 rounded-md mt-5 shadow-sm border border-gray-200 mb-4">
          <div className="font-semibold text-sm flex gap-1 items-center">
            <MdFilterListAlt className="inline-block" />
            <div>Filtros Avançados</div>
          </div>
          <div
            className={`grid grid-cols-1 md:grid-cols-2 gap-2 ${
              userPermission === "POWER_USER"
                ? "lg:grid-cols-5"
                : "lg:grid-cols-4"
            }`}
          >
            <div className="mt-4">
              <Input
                register={register}
                label="Data de cadastro"
                name="createdAt"
                type="date"
              />
            </div>
            <div className="mt-4">
              <SelectInput
                register={register}
                label="Tipo de cliente"
                name="typeCustomer"
              >
                <option value="">Todos os tipos</option>
                <option value="CPF">Física</option>
                <option value="CNPJ">Jurídica</option>
              </SelectInput>
            </div>
            <div className="mt-4">
              <SelectInput
                register={register}
                label="Tipo de pagamento"
                name="typePayment"
              >
                <option value="">Todos os tipos</option>
                <option value="PRE">Pré-Pago</option>
                <option value="POS">Pós-Pago</option>
              </SelectInput>
            </div>
            <div className="mt-4">
              <SelectInput
                register={register}
                label="Status do cliente"
                name="status"
              >
                <option value="">Todos os status</option>
                <option value={1}>Ativo</option>
                <option value={0}>Bloqueado</option>
                <option value={-1}>Inadimplente</option>
              </SelectInput>
            </div>
            <div className="mt-4">
              <SelectInput
                register={register}
                label="Cliente integrador"
                name="isIntegrator"
              >
                <option value="">Todos os clientes</option>
                <option value={1}>Sim</option>
                <option value={0}>Não</option>
              </SelectInput>
            </div>
          </div>
        </div>
        <div className="flex gap-1 w-full pl-3 pr-2 py-2 md:py-1 rounded-md bg-gray-300">
          <input
            type="text"
            placeholder="Busque por nome, telefone, e-mail ou documento do cliente..."
            className="border-0 py-1 text-sm mt-1 focus:outline-none focus:ring-0 focus:border-gray-300 px-0 w-full bg-gray-300 placeholder:text-gray-700"
            onChange={(e) => setSearchName(e.target.value)}
            value={searchName}
          />
          <Button
            size="sm"
            className="flex items-center bg-secondary w-20"
            type="submit"
          >
            <IoMdSearch />
          </Button>
        </div>
      </form>

      {listCustomers?.length > 0 || isLoadingListCustomers ? (
        <>
          <small
            className="gap-2 items-center mt-5 mb-1 flex md:hidden justify-center"
            style={{ fontSize: 10 }}
          >
            <span>
              Deslize para o lado para visualizar todas as informações
            </span>{" "}
            <FaArrowsLeftRight />
          </small>
          <div className="overflow-x-auto shadow-md rounded-lg mt-0 md:mt-5">
            <Table striped className="text-xs xl:text-sm">
              <Table.Head>
                <Table.HeadCell className="bg-gray-300">Cliente</Table.HeadCell>
                <Table.HeadCell className="text-center bg-gray-300">
                  Data cadastro
                </Table.HeadCell>
                <Table.HeadCell className="text-center bg-gray-300">
                  Representante
                </Table.HeadCell>
                <Table.HeadCell className="text-center bg-gray-300">
                  Tipo
                </Table.HeadCell>
                <Table.HeadCell className="text-center bg-gray-300 relative">
                  Tipo de pagamento
                </Table.HeadCell>
                <Table.HeadCell className="text-center bg-gray-300">
                  Status
                </Table.HeadCell>
                <Table.HeadCell className="text-center bg-gray-300">
                  Ações
                </Table.HeadCell>
              </Table.Head>

              <Table.Body className="divide-y">
                {!isLoadingListCustomers ? (
                  <>
                    {listCustomers?.length > 0 && (
                      <>
                        {listCustomers.map((customer, index) => (
                          <Table.Row
                            key={index}
                            className="bg-white dark:border-gray-700 dark:bg-gray-800"
                          >
                            <Table.Cell className="font-medium text-gray-900 dark:text-white py-2">
                              {customer.typeCustomer === "CPF"
                                ? customer.name
                                : customer.socialReason}
                            </Table.Cell>
                            <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                              {moment(customer.createdAt).format("DD/MM/yyyy")}
                            </Table.Cell>
                            <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                              {customer?.ParentCompany
                                ? `${
                                    customer?.ParentCompany?.name ||
                                    customer?.ParentCompany?.socialReason
                                  }`
                                : "-"}
                            </Table.Cell>
                            <Table.Cell className="font-medium text-gray-900 dark:text-white text-center py-2">
                              {customer.typeCustomer === "CPF"
                                ? "Física"
                                : "Jurídica"}
                            </Table.Cell>
                            <Table.Cell className="text-center py-2">
                              <Badge className="w-fit mx-auto">
                                {customer.typePayment === "PRE"
                                  ? "Pré-pago"
                                  : "Pós-pago"}
                              </Badge>
                            </Table.Cell>
                            <Table.Cell className="text-center py-2">
                              {customer.status === 1 ? (
                                <Badge color="green" className="mx-auto w-fit">
                                  Ativo
                                </Badge>
                              ) : customer.status === 0 ? (
                                <Badge
                                  color="failure"
                                  className="mx-auto w-fit"
                                >
                                  Bloqueado
                                </Badge>
                              ) : (
                                <Badge
                                  color="failure"
                                  className="mx-auto w-fit"
                                >
                                  Inadimplente
                                </Badge>
                              )}
                            </Table.Cell>
                            <Table.Cell className="text-center py-1">
                              <div className="flex gap-2 justify-center items-center">
                                <Tooltip
                                  id="tooltip-edit-permissions"
                                  content="Editar Permissões"
                                />
                                <TbLockSearch
                                  data-tooltip-id="tooltip-edit-permissions"
                                  fontSize="16"
                                  className="text-gray-500 cursor-pointer"
                                  onClick={() =>
                                    handleEditPermissionQueries(customer)
                                  }
                                />
                                {/* <Tooltip
                                  id="tooltip-edit-customer"
                                  content="Visualizar detalhes do cliente"
                                />
                                <MdOutlineRemoveRedEye
                                  data-tooltip-id="tooltip-edit-customer"
                                  fontSize="16"
                                  className="text-gray-500 cursor-pointer"
                                  onClick={() =>
                                    navigate(
                                      `/admin/customers/${customer?.id}`,
                                      { replace: true }
                                    )
                                  }
                                /> */}
                              </div>
                            </Table.Cell>
                          </Table.Row>
                        ))}
                      </>
                    )}
                  </>
                ) : (
                  <TableLoading cols={7} />
                )}
              </Table.Body>
            </Table>
          </div>

          {totalCount > 0 && (
            <div className="mt-3 text-center text-sm text-gray-600">
              Exibindo {(currentPage - 1) * itemsPerPage + 1}–
              {Math.min(currentPage * itemsPerPage, totalCount)} de {totalCount}{" "}
              registros
            </div>
          )}

          {totalPages > 1 && (
            <div className="flex overflow-x-auto justify-center mt-3">
              <Pagination
                layout="pagination"
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={onPageChange}
                previousLabel=""
                nextLabel=""
                showIcons
              />
            </div>
          )}
        </>
      ) : (
        <EmptyTable icon="person_off">Nenhum cliente cadastrado</EmptyTable>
      )}

      <Drawer
        title={`Visualizar faturamento`}
        onClose={setIsDrawerViewInvoice}
        isOpen={isDrawerViewInvoice}
        className={"w-full md:w-4/6 lg:w-3/6 xl:w-2/6"}
      >
        <CompanyInvoiceForm
          company={selectedCompany}
          onClose={setIsDrawerViewInvoice}
          isDrawerOpen={isDrawerViewInvoice}
          companyType="CUSTOMER"
        />
      </Drawer>

      <Drawer
        title={`Permissões`}
        onClose={setIsDrawerPermissionQueries}
        isOpen={isDrawerPermissionQueries}
        className={"w-full md:w-4/6 lg:w-2/6"}
      >
        <CompanyQueriesForm
          company={selectedCompany}
          categories={categories}
          onClose={setIsDrawerPermissionQueries}
          fetchCompanies={() =>
            queryClient.invalidateQueries(["listCustomers", currentPage])
          }
        />
      </Drawer>
      <Drawer
        title={`Editar cliente`}
        onClose={setIsDrawerEditCustomer}
        isOpen={isDrawerEditCustomer}
        className={"w-full md:w-4/6 lg:w-3/6"}
      >
        <CompanyEditForm
          company={selectedCompany}
          onClose={setIsDrawerEditCustomer}
          categories={categories}
          fetchCompanies={() =>
            queryClient.invalidateQueries(["listCustomers", currentPage])
          }
        />
      </Drawer>

      <ModalDelete
        title={`Deseja ${
          typeBlock === 0 ? "bloquear" : "desbloquear"
        } este cliente?`}
        isOpen={isOpenModalBlock}
        setOpenModal={setOpenModalBlock}
        isLoading={isLoadingBlock}
        handleDelete={() => blockUnlockCustomer(typeBlock)}
      />
    </>
  );
};

export default AdminCustomersTableSpecific;
